module.exports = __webpack_public_path__ + "img/setting-07.ce9cb2b0.png";